export default "__VITE_ASSET__DyztUe$U__"